<div class="popupFormulario">
	<div class="container">
		@if (data.title) {
			<h1 class="color-title" mat-dialog-title>
				{{ data.title }}
			</h1>
		}
		@if (data.subtitle) {
			<h2 mat-dialog-content>{{ data.subtitle }}</h2>
		}
		<div class="mat-typography">
			<p>Sólo se permite importar archivos .xlsx</p>
			<div class="upload-section">
				<button
					mat-fab
					color="accent"
					(click)="fileInput.click()"
					class="upload-button"
					matTooltip="Subir archivo"
				>
					<lucide-icon name="file-up"></lucide-icon>
				</button>
				<mat-label>{{ fileName }}</mat-label>
				<input
					hidden
					(change)="checkFile($event)"
					#fileInput
					type="file"
					accept=".xlsx"
					id="file"
				/>
			</div>
		</div>
		@if (validateError) {
			<div>
				<p class="p-error mat-typography">
					No se pudo cargar el archivo. Solo se admite formato Excel (.xlsx)
				</p>
			</div>
		}
	</div>
	<div class="popup-actions-container mt-2">
		<app-button
			(btnClick)="close()"
			buttonText="Cancelar"
			color="warn"
		></app-button>
		<app-button
			(btnClick)="uploadFile()"
			buttonText="Procesar"
			[isDisabled]="fileName.length === 0 || validateError"
		></app-button>
	</div>
</div>
